export default __webpack_public_path__ + "static/media/qa.172aefad.svg";